import { bearerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const clerk = defineConnector({
  identifier: "clerk",
  name: "Clerk",
  tagLine: "User authentication and management",
  logo,
  protocol: "http",
  tags: ["engineering"],
  defaultUrlPattern: () => "https://api\\.clerk\\.com/.*",
  auth: (app) => bearerAuth(app.secret.apiKey),
  steps: [
    {
      title: "Find your Clerk API credentials",
      items: [
        {
          kind: "markdown",
          content:
            "In the [Clerk Dashboard](https://dashboard.clerk.com/), select your application and go to **API Keys**. Copy your Secret Key (it starts with `sk_test_` or `sk_live_`).",
        },
      ],
    },
    {
      title: "Enter your API credentials",
      items: [
        {
          kind: "markdown",
          content:
            "Enter the API credentials from your Clerk account settings.",
        },
        {
          kind: "input",
          label: "Secret Key",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
          placeholder: "sk_test_abcdefghijklmnop123456789",
          helperText:
            "Your Clerk Secret Key (starts with sk_test_ or sk_live_)",
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://api.clerk.com/v1/jwks",
  },
});
